export default __webpack_public_path__ + "static/media/IBMPlexSans-LightItalic.0f680156.woff";